var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FadeTransition',[_c('KeepAlive',[_c(_vm.step.component,{tag:"component",attrs:{"on-mfa-login-success":_vm.onMfaLoginSuccess,"info-mfa":_vm.infoMfa,"login-data":_vm.loginData},on:{"next-step":_vm.handleNextStep,"previous-step":_vm.handlePreviousStep}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }